export default class CevirilecekDovizTutarIstek {
    tlTutar: number = 0;
    dolarTutar: number = 0;
    euroTutar: number = 0;
    cevirilecekParaBirimi: number = 1;
    paraBirimi: number = 1;
    dovizTarihi?: string = null;
};